import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';

function LogKayitlari() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState('HEPSI'); // Filtreleme durumu
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Son 200 işlemi çek
    const q = query(
      collection(db, 'islem_gecmisi'),
      orderBy('zaman', 'desc'),
      limit(200) 
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const logList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setLogs(logList);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // İstatistikler
  const stats = useMemo(() => {
    return {
      total: logs.length,
      errors: logs.filter(l => l.islemTuru && (l.islemTuru.includes('Silme') || l.islemTuru.includes('Hata'))).length,
      updates: logs.filter(l => l.islemTuru && l.islemTuru.includes('Güncelleme')).length,
      logins: logs.filter(l => l.islemTuru && l.islemTuru.includes('Giriş')).length
    };
  }, [logs]);

  // Filtreleme Mantığı
  const filteredLogs = logs.filter(log => {
    if (!log.islemTuru) return false;
    if (filter === 'HEPSI') return true;
    if (filter === 'HATA') return log.islemTuru.includes('Silme') || log.islemTuru.includes('Hata');
    if (filter === 'ISLEM') return log.islemTuru.includes('Ekleme') || log.islemTuru.includes('Güncelleme');
    if (filter === 'GIRIS') return log.islemTuru.includes('Giriş');
    return true;
  });

  const formatDate = (timestamp) => {
    if (!timestamp) return 'UNKNOWN';
    return timestamp.toDate().toLocaleString('tr-TR');
  };

  const getColor = (tur) => {
    if (tur && (tur.includes("Silme") || tur.includes("Hata"))) return "#ff3333"; // Kırmızı
    if (tur && tur.includes("Ekleme")) return "#33ff33"; // Yeşil
    if (tur && tur.includes("Güncelleme")) return "#ffff33"; // Sarı
    if (tur && tur.includes("Giriş")) return "#00ffff"; // Mavi
    return "#cccccc"; 
  };

  // Satıra tıklayınca git
  const handleLogClick = (log) => {
    if (log.hedefId && log.hedefSayfa) {
        if (log.hedefSayfa === 'tedarikciler') {
            navigate(`/tedarikciler/${log.hedefId}`);
        } else if (log.hedefSayfa === 'cariler') {
            navigate(`/cariler/${log.hedefId}`);
        }
    }
  };

  return (
    <div style={{
      backgroundColor: '#000000',
      color: '#00ff00',
      fontFamily: '"Courier New", Courier, monospace',
      // Tam Ekran Ayarları (Navbar ve Footer'ı kapatması için)
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      zIndex: 999999, overflowY: 'auto', padding: '20px', boxSizing: 'border-box'
    }}>
      
      {/* ÜST BİLGİ ÇUBUĞU (HUD) */}
      <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '2px solid #00ff00', paddingBottom: '10px', marginBottom: '20px' }}>
        <div>
            <h1 style={{ fontSize: '1.5rem', margin: 0, letterSpacing: '2px' }}>
              <span className="blink">█</span> ZEZE_TEKNIK // KONSOL
            </h1>
            <div style={{fontSize: '0.8rem', opacity: 0.7, marginTop: '5px'}}>
                STATUS: ONLINE | ENCRYPTION: AES-256 | USER: ROOT
            </div>
        </div>
        <div style={{textAlign: 'right'}}>
            <div style={{fontSize: '0.9rem'}}>
                <span style={{color:'#fff'}}>TOTAL_OPS:</span> {stats.total} | 
                <span style={{color:'#ff3333'}}> ALERTS:</span> {stats.errors} | 
                <span style={{color:'#ffff33'}}> UPDATES:</span> {stats.updates}
            </div>
            <button 
                onClick={() => navigate('/')} 
                style={{
                    background: 'transparent', color: '#00ff00', border: '1px solid #00ff00',
                    padding: '5px 15px', cursor: 'pointer', fontFamily: 'inherit', fontWeight: 'bold',
                    marginTop: '10px', textTransform: 'uppercase'
                }}
                onMouseOver={(e) => {e.target.style.background = '#00ff00'; e.target.style.color = '#000'}}
                onMouseOut={(e) => {e.target.style.background = 'transparent'; e.target.style.color = '#00ff00'}}
            >
                [ SYSTEM_LOGOUT ]
            </button>
        </div>
      </div>

      {/* FİLTRE BUTONLARI */}
      <div style={{marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap'}}>
          <button onClick={() => setFilter('HEPSI')} className={`filter-btn ${filter === 'HEPSI' ? 'active' : ''}`}>ALL_LOGS</button>
          <button onClick={() => setFilter('HATA')} className={`filter-btn ${filter === 'HATA' ? 'active' : ''}`} style={{borderColor:'#ff3333', color: filter === 'HATA' ? '#000' : '#ff3333'}}>ERRORS / DELETES</button>
          <button onClick={() => setFilter('ISLEM')} className={`filter-btn ${filter === 'ISLEM' ? 'active' : ''}`} style={{borderColor:'#33ff33', color: filter === 'ISLEM' ? '#000' : '#33ff33'}}>OPERATIONS</button>
          <button onClick={() => setFilter('GIRIS')} className={`filter-btn ${filter === 'GIRIS' ? 'active' : ''}`} style={{borderColor:'#00ffff', color: filter === 'GIRIS' ? '#000' : '#00ffff'}}>LOGINS</button>
      </div>

      {/* TERMİNAL TABLOSU */}
      <div style={{ border: '1px solid #333', padding: '10px', minHeight: '60vh', backgroundColor: '#050505' }}>
        {loading ? (
          <p className="blink" style={{fontSize: '1.2rem', color: '#00ff00'}}>_ READING_MEMORY_BLOCKS...</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
            <thead>
              <tr style={{ textAlign: 'left', borderBottom: '1px solid #333', color: '#666' }}>
                <th style={{ padding: '8px' }}>TIME</th>
                <th style={{ padding: '8px' }}>OP_TYPE</th>
                <th style={{ padding: '8px' }}>PAYLOAD / MESSAGE</th>
                <th style={{ padding: '8px' }}>OPERATOR</th>
                <th style={{ padding: '8px' }}>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {filteredLogs.map((log) => (
                <tr 
                    key={log.id} 
                    style={{ borderBottom: '1px solid #111', transition: '0.2s' }} 
                    className="log-row"
                    onClick={() => handleLogClick(log)}
                >
                  <td style={{ padding: '8px', color: '#444' }}>[{formatDate(log.zaman)}]</td>
                  <td style={{ padding: '8px' }}>
                    <span style={{ color: getColor(log.islemTuru) }}>
                        {log.islemTuru ? log.islemTuru.toUpperCase() : 'UNKNOWN'}
                    </span>
                  </td>
                  <td style={{ padding: '8px', color: '#ddd' }}>{log.detay}</td>
                  <td style={{ padding: '8px', color: '#888' }}>{log.yapan}</td>
                  <td style={{ padding: '8px' }}>
                    {log.hedefId && (
                        <span style={{border:'1px solid #444', padding:'2px 5px', fontSize:'0.7rem', color:'#aaa'}}>
                            GOTO_LINK &gt;
                        </span>
                    )}
                  </td>
                </tr>
              ))}
              {filteredLogs.length === 0 && (
                  <tr>
                      <td colSpan="5" style={{ textAlign: 'center', padding: '50px', color: '#555' }}>
                          {'>'} NO_DATA_FOUND_IN_SECTOR_0
                      </td>
                  </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
      
      <style>{`
        .blink { animation: blinker 1s linear infinite; }
        @keyframes blinker { 50% { opacity: 0; } }

        .filter-btn {
            background: #000; border: 1px solid #666; color: #666;
            padding: 5px 15px; cursor: pointer; font-family: inherit; font-weight: bold;
            text-transform: uppercase;
        }
        .filter-btn.active { background: #666; color: #000; }
        .filter-btn:hover { opacity: 0.8; }

        .log-row:hover { background-color: #111; cursor: pointer; }
        .log-row:hover td { color: #fff !important; }
        
        /* Scrollbar */
        ::-webkit-scrollbar { width: 8px; }
        ::-webkit-scrollbar-track { background: #000; }
        ::-webkit-scrollbar-thumb { background: #333; border: 1px solid #00ff00; }
        ::-webkit-scrollbar-thumb:hover { background: #00ff00; }
      `}</style>
    </div>
  );
}

export default LogKayitlari;